/**
 * Hack to work around mobile browser inconsistencies in sizing when the navigation bar is
 * collapsed.
 *
 * We set the initial view port height and the current one (based on the resize event).
 *
 * Avoid using those variables directly, instead use the `vh-non-reactive` and `vh-reactive` mixins.
 *
 * @see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */
import throttle from 'lodash/throttle';
import { GLOBAL } from 'saddlebag-browser';

const $window = GLOBAL.getWindow();
const $document = GLOBAL.getDocument();

const setViewportHeightProperty = (propName: string) => () => {
  const vh = $window.innerHeight * 0.01;

  if ($document && $document.documentElement) {
    $document.documentElement.style.setProperty(propName, `${vh}px`);
  }
};

const setReactiveVhProp = setViewportHeightProperty('--vh');
const setNonReactiveVhProp = setViewportHeightProperty('--initial-vh');
$window.addEventListener('resize', throttle(setReactiveVhProp, 100));

export const setupViewportHeight = () => {
  setNonReactiveVhProp();
  setReactiveVhProp();
};
